<template>
  <main class="mt-5">
    <span id="add-btn">
      <button
        :disabled="hasPermission('write_admin') ? false : true"
        @click="createItem"
        
        class="btn btn-success"
      >
        مدیر جدید
      </button>
    </span>
    <b-tooltip v-if="!hasPermission('write_admin')" target="add-btn" triggers="hover">
      شما به این بخش دسترسی ندارید
    </b-tooltip>

    <!-- مودال ثبت / ویرایش بدون FormModal -->
    <b-modal
      id="admin"
      ref="adminModal"
      :title="modalTitle"
      ok-title="ثبت"
      cancel-title="انصراف"
      :ok-disabled="disabled"
      @ok="onModalOk"
      size="lg"
    >
      <form @submit.prevent="submitForm">
        <div class="row">
          <!-- نام -->
          <b-form-group class="col-md-6" label="نام" label-for="name">
            <b-form-input
              id="name"
              v-model="form.name"
              :disabled="disabled"
              placeholder="نام مدیر"
            ></b-form-input>
          </b-form-group>

          <!-- نام کاربری -->
          <b-form-group class="col-md-6" label="نام کاربری" label-for="username">
            <b-form-input
              id="username"
              v-model="form.username"
              :disabled="disabled"
              placeholder="نام کاربری"
              required
            ></b-form-input>
          </b-form-group>

          <!-- ایمیل -->
          <b-form-group class="col-md-6" label="ایمیل" label-for="email">
            <b-form-input
              id="email"
              type="email"
              v-model="form.email"
              :disabled="disabled"
              placeholder="ایمیل"
            ></b-form-input>
          </b-form-group>

          <!-- موبایل -->
          <b-form-group class="col-md-6" label="شماره تماس" label-for="mobile">
            <b-form-input
              id="mobile"
              v-model="form.mobile"
              :disabled="disabled"
              placeholder="شماره تماس"
            ></b-form-input>
          </b-form-group>

          <!-- رمز عبور -->
          <b-form-group class="col-md-6" label="رمز عبور" label-for="password">
            <b-form-input
              id="password"
              type="password"
              v-model="form.password"
              :disabled="disabled"
              :placeholder="mode === 'create' ? 'رمز عبور (حداقل ۶ کاراکتر)' : 'خالی بگذارید تا تغییر نکند'"
            ></b-form-input>
            <small v-if="mode === 'edit'" class="text-muted">
              در صورت خالی بودن، رمز عبور تغییر نمی‌کند
            </small>
          </b-form-group>

          <!-- نقش -->
          <b-form-group class="col-md-6" label="نقش" label-for="role">
            <multiselect
              id="role"
              v-model="form.role"
              :options="roleOptions"
              :disabled="disabled"
              placeholder="انتخاب نقش"
              label="label"
              track-by="id"
              :searchable="true"
              :allow-empty="false"
            >
              <template slot="noOptions">موردی یافت نشد</template>
              <template slot="noResult">موردی یافت نشد</template>
            </multiselect>
          </b-form-group>

          <!-- نوع فروش -->
          <b-form-group class="col-md-6" label="نوع فروش" label-for="sell_type">
            <multiselect
              id="sell_type"
              v-model="form.sell_type"
              :options="sellTypeOptions"
              :disabled="disabled"
              placeholder="انتخاب نوع فروش"
              label="label"
              track-by="id"
              :searchable="true"
              :allow-empty="false"
            >
              <template slot="noOptions">موردی یافت نشد</template>
              <template slot="noResult">موردی یافت نشد</template>
            </multiselect>
          </b-form-group>

          <!-- POS ها (مولتی سلکت) -->
          <b-form-group class="col-md-12" label="دستگاه‌های POS" label-for="pos">
            <multiselect
              id="pos"
              v-model="form.pos"
              :options="posOptions"
              :disabled="disabled"
              placeholder="انتخاب دستگاه‌های POS"
              label="label"
              track-by="id"
              :searchable="true"
              :multiple="true"
              :close-on-select="false"
            >
              <template slot="noOptions">موردی یافت نشد</template>
              <template slot="noResult">موردی یافت نشد</template>
            </multiselect>
            <small class="text-muted mt-1 d-block">
              می‌توانید چند POS را همزمان انتخاب کنید
            </small>
          </b-form-group>
        </div>
      </form>
    </b-modal>

    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold">مدیران</h5>
        <div style="flex:1"></div>
        <b-button v-b-toggle.filter :variant="hasFilter() ? 'secondary' : 'primary'">
          <span class="fe fe-search pt-1" style="font-size: 17px;"></span>
        </b-button>
      </div>
      <b-collapse id="filter" class="mt-2 mx-5">
        <b-card>
          <form @submit.prevent="filterItem()">
            <div class="row mt-5">
              <b-form-group class="col-md-6">
                <b-form-input
                  :disabled="disabled"
                  placeholder="نام مدیر"
                  v-model="filter.name"
                ></b-form-input>
              </b-form-group>
              <b-form-group class="col-md-6">
                <b-form-input
                  :disabled="disabled"
                  placeholder="نام کاربری"
                  v-model="filter.username"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="text-center mt-3">
              <button :disabled="disabled" type="submit" class="btn btn-primary px-5">
                جستجو
              </button>
              <button
                :disabled="disabled"
                @click="resetFilter"
                class="btn btn-warning px-5 mr-3"
              >
                برداشتن فیلتر
              </button>
              <button
                :disabled="disabled"
                @click="$root.$emit('bv::toggle::collapse', 'filter')"
                class="btn btn-secondary px-5 mr-3"
              >
                بستن
              </button>
            </div>
          </form>
        </b-card>
      </b-collapse>
      <div class="card-body">
        <div>
          <b-table responsive hover bordered :items="items.data" :fields="fields">
            <template v-slot:cell(edit)="data">
              <span :id="'edit-btn-' + data.item.id">
                <a
                  :disabled="!hasPermission('modify_admin') ? true : false"
                  class="action-btns1 pt-1 px-2"
                  @click="editItem(data.index)"
                >
                  <i class="feather feather-edit text-primary"></i>
                </a>
              </span>
              <b-tooltip
                v-if="!hasPermission('modify_admin')"
                :target="'edit-btn-' + data.item.id"
                triggers="hover"
              >
                شما به این بخش دسترسی ندارید
              </b-tooltip>
            </template>
            <template v-slot:cell(created_at)="data">
              {{ data.item.created_at | persianDate }}
            </template>
            <template v-slot:cell(delete)="data">
              <span :id="'delete-btn-' + data.item.id">
                <a
                  :disabled="!hasPermission('delete_admin') ? true : false"
                  class="action-btns1 pt-1 px-2"
                  @click="deleteItem(data.item.id)"
                >
                  <i class="feather feather-trash-2 text-danger"></i>
                </a>
              </span>
              <b-tooltip
                v-if="!hasPermission('delete_admin')"
                :target="'delete-btn-' + data.item.id"
                triggers="hover"
              >
                شما به این بخش دسترسی ندارید
              </b-tooltip>
            </template>
          </b-table>
          <Loading v-if="$root.isEmptyObject(items)" />
          <pagination
            v-else-if="items.data != ''"
            :disabled="disabled"
            :limit="2"
            :data="items"
            @pagination-change-page="changePage"
          ></pagination>
          <div v-else class="alert alert-danger">موردی یافت نشد</div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import AdminImpl from '@@/core/pages/Admin/AdminImpl'
export default {
  extends: AdminImpl
}
</script>
